import { render, staticRenderFns } from "./DeliveryOrderManager.vue?vue&type=template&id=4a671645&"
import script from "./DeliveryOrderManager.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderManager.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports